import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IRouteSession {
  id: number;
  job_day: number;
  vehicleId: string | number;
  routeId: string | number;
  ftlId: string | number | null;
  ftlCalc: number;
  status: number;
  createDate: string;
  autoTransfer: number;
  nextDay: number;
  descs: string | null;
  outTime: string | null;
  arrivalTime: string | null;
}

export class IRouteSessionResponse {
  @Type(() => IRouteSession)
  result: IRouteSession;
}

export class IRouteSessionFileDownloadUrl {
  result: string;
}

export class IRouteSessionListResponse extends IPagination {
  @Type(() => IRouteSession)
  results: IRouteSession[];
}

export class IRouteSessionQueryDto extends IQueryPaginationDto {
  /** Teslimat evrakı var mı (true/false) — Günlük Rota Dosya Kontrolü */
  fileStatus?: string;
  /** Bölge (bolge=999 nokta) id — rotanın çıkış noktası */
  regionId?: string;
  status?: string;
  dateCreatedStart?: string;
  autoTransfer?: string;
  dateCreatedEnd?: string;
  nextDay?: string;
  id?: string | number;
  descs?: string;
  outTime?: string;
  arrivalTime?: string;
  jobDay?: string;
  vehicleId?: string | number;
  routeId?: string;
  ftlId?: string | number;
  driverId?: string | number;
  routeName?: string;
  billType?: number;
}

export class IPostRouteSessionsBodyDto {
  vehicleId: string | number;
  routeId: string | number;
  ftlId: string | number | null;
  // Ertesi güne aktarma süreci: 0=aktarma yok, 1=aktar+geri getir, 99=aktar geri getirme.
  // Cron (routeSession-cron) bu alanı okur.
  autoTransfer: number;
  nextDay?: number;
  descs: string;
  status: number;
  jobDay: number;
  createDate: string | Date;
  ftlCalc: null;
}

export class IPostRouteBodyDto {
  name: string;
  bill_type: number;
  origin_point: number;
  connected_point: number | null;
  third_party_point: number | null;
  length: number | null;
  status: number;
  subroute: number;
  ord: number;
  array: number;
  delivery_time: number;
  hidden: number;
  last_route: number;
  return_route: number;
}

export class IPatchRouteBodyDto {
  name?: string;
  bill_type?: number;
  origin_point?: number;
  connected_point?: number | null;
  third_party_point?: number | null;
  length?: number | null;
  status?: number;
  subroute?: number;
  ord?: number;
  array?: number;
  delivery_time?: number | null;
  tolerance?: number | null;
  hidden?: number;
  last_route?: number;
  return_route?: number;
}

export class IPostRouteSessionResponseDto {
  result: {
    id: string | number;
    jobDay: number;
    vehicleId: number;
    routeId: string | number;
    ftlId: number | null;
    ftlCalc: null | number;
    status: number;
    createDate: string;
    autoTransfer: number;
    nextDay: number;
    descs: string;
    outTime: string | null;
    arrivalTime: string | null;
  };
}

export class IPatchRouteSessionsBodyDto {
  vehicleId?: string | number;
  routeId?: string | number;
  ftlId?: string | number | null;
  nextDay?: number;
  descs?: string;
  status?: number;
  jobDay?: number;
  createDate?: string | Date;
  ftlCalc?: null;
}

export class IRouteSessionFilesListResponse extends IPagination {
  @Type(() => IRouteSessionsFiles)
  results: IRouteSessionsFiles[];
}

export class IRouteSessionsFiles {
  id: number;
  userId: number;
  status: number;
  fileSize: number;
  type: string;
  fileType: string;
  dailyrouteId: number;
  date: string | Date;
  fileUrl: string;
  fileId: string;
}

interface Package {
  package_id: number;
  barcode: string;
  boxcode: string;
  compSpecialCode: string;
  fromName: string;
  toName: string;
  toPhoneNo: string;
  toAddress: string;
  toSubCity: string;
  toCity: string;
  desi: number;
  date: string;
}

export class IRouteSessionReportResponse {
  id: number;
  job_day: number;
  date: string;
  route_name: string;
  driver_name: string;
  plaka: string;
  packages: Package[];
}
